"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function generateTraceId() {
    var digits = '0123456789abcdef';
    var n = '';
    for (var i = 0; i < 16; i++) {
        var rand = Math.floor(Math.random() * 16);
        n += digits[rand];
    }
    return n;
}
exports.generateTraceId = generateTraceId;
//# sourceMappingURL=generateTraceId.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@utex/adonis-client/dist/utils/generateTraceId.js
// module id = 1633
// module chunks = 118